export const PREPARATION_EVIDENCE_GROUPS = Object.freeze({
  CURRENT_PROFILE: 'current_profile',
  RECENT_EVENTS: 'recent_events',
  DOCUMENTS: 'documents',
});

export const PREPARATION_GROUP_LABELS = Object.freeze({
  [PREPARATION_EVIDENCE_GROUPS.CURRENT_PROFILE]: 'Current information',
  [PREPARATION_EVIDENCE_GROUPS.RECENT_EVENTS]: 'Recent events',
  [PREPARATION_EVIDENCE_GROUPS.DOCUMENTS]: 'Documents',
});

const GROUP_ORDER = [
  PREPARATION_EVIDENCE_GROUPS.CURRENT_PROFILE,
  PREPARATION_EVIDENCE_GROUPS.RECENT_EVENTS,
  PREPARATION_EVIDENCE_GROUPS.DOCUMENTS,
];

const toMillis = (value) => {
  const millis = value ? new Date(value).getTime() : 0;
  return Number.isNaN(millis) ? 0 : millis;
};

export const groupPreparationEvidence = (evidence = []) => {
  const grouped = new Map(GROUP_ORDER.map((group) => [group, []]));

  evidence.forEach((item) => {
    const inferredGroup = ['timeline', 'dailyLog'].includes(item?.sourceType)
      ? PREPARATION_EVIDENCE_GROUPS.RECENT_EVENTS
      : item?.sourceType === 'document'
        ? PREPARATION_EVIDENCE_GROUPS.DOCUMENTS
        : PREPARATION_EVIDENCE_GROUPS.CURRENT_PROFILE;
    const group = grouped.has(item?.group) ? item.group : inferredGroup;
    grouped.get(group).push(item);
  });

  grouped.get(PREPARATION_EVIDENCE_GROUPS.RECENT_EVENTS)
    .sort((a, b) => toMillis(b.occurredAt) - toMillis(a.occurredAt));

  return GROUP_ORDER
    .map((group) => ({ group, label: PREPARATION_GROUP_LABELS[group], items: grouped.get(group) }))
    .filter(({ items }) => items.length);
};

export const getVisiblePreparationEvidence = ({ group, items = [], showAll = false, limit = 5 }) => (
  group === PREPARATION_EVIDENCE_GROUPS.RECENT_EVENTS && !showAll
    ? items.slice(0, limit)
    : items
);

const MEDICATION_CLASSIFICATION_LABELS = Object.freeze({
  current_profile: 'Current Profile',
  medication_changes: 'Medication changes',
  sleep: 'Sleep',
  mood_behavior: 'Mood / behavior',
  appetite_intake: 'Appetite / intake',
  other_health: 'Other health',
  needs_confirmation: 'Needs confirmation',
});

export const groupMedicationPreparationEvidence = (evidence = []) => {
  const grouped = new Map(Object.keys(MEDICATION_CLASSIFICATION_LABELS).map((key) => [key, []]));
  evidence.forEach((item) => {
    const classification = grouped.has(item.classification) ? item.classification : 'other_health';
    grouped.get(classification).push(item);
  });
  return [...grouped.entries()]
    .map(([group, items]) => ({ group, label: MEDICATION_CLASSIFICATION_LABELS[group], items }))
    .filter(({ items }) => items.length);
};
